import React from 'react';
import Container from './SummaryText.styl';
import Copy from '../../../Utils/Copy';
import Markdown from '../../atoms/Markdown';

export type VideoProps = {
  type: string;
  authorization?: string;
  mediaCode?: string;
  text: string;
  onClose: () => void;
  opened?: boolean;
};
// eslint-disable-next-line import/no-anonymous-default-export
export default ({
  type,
  authorization,
  mediaCode,
  text,
  onClose,
  opened = false,
}: VideoProps) => {
  if (!opened) {
    return null;
  }

  return (
    <Container className="smartplayer__summaryText">
      <div className="summaryText__backdrop" onClick={() => onClose()}></div>
      <div className="summaryText__container">
        <div className="summaryText__heading">
          <h1 className="summaryText__title">{type === 'SUMMARY_TEXT' ? 'Resumo' : 'E-Book'}</h1>
          <button type="button" className="summaryText__btn summaryText__btn--close" onClick={() => onClose()}>
            <svg className="svg-inline--fa fa-xmark" aria-hidden="true" focusable="false" data-prefix="fal" data-icon="xmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" data-fa-i2svg="">
              <path fill="currentColor" d="M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.5 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z"></path>
            </svg>
          </button>
        </div>
        <hr className="summaryText_hr" />
        <div className="summaryText__content">
          <Markdown>
            {text}
          </Markdown>
        </div>
        <div className="summaryText__footer">
          <button className="summaryText__btn summaryText__btn--copy" onClick={() => Copy(text)}>
            Copiar
          </button>
          <button className="summaryText__btn summaryText__btn--download" disabled={type === 'SUMMARY_TEXT'} onClick={() => {
            window.open(window.location.origin + `/print-ebook/player/${mediaCode}?authorization=${authorization}`, '_blank')
          }}>
            Download
          </button>
        </div>
      </div>
    </Container>
  );
};
